import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Feature } from '../../motion/features/Feature.mjs';
import { noop } from '../../utils/noop.mjs';
import { VisualElementDragControls } from './VisualElementDragControls.mjs';
var DragGesture = /*#__PURE__*/function (_Feature) {
  function DragGesture(node) {
    var _this;
    _classCallCheck(this, DragGesture);
    _this = _callSuper(this, DragGesture, [node]);
    _this.removeGroupControls = noop;
    _this.removeListeners = noop;
    _this.controls = new VisualElementDragControls(node);
    return _this;
  }
  _inherits(DragGesture, _Feature);
  return _createClass(DragGesture, [{
    key: "mount",
    value: function mount() {
      // If we've been provided a DragControls for manual control over the drag gesture,
      // subscribe this component to it on mount.
      var _this$node$getProps = this.node.getProps(),
        dragControls = _this$node$getProps.dragControls;
      if (dragControls) {
        this.removeGroupControls = dragControls.subscribe(this.controls);
      }
      this.removeListeners = this.controls.addListeners() || noop;
    }
  }, {
    key: "unmount",
    value: function unmount() {
      this.removeGroupControls();
      this.removeListeners();
    }
  }]);
}(Feature);
export { DragGesture };